import { initAuthApi } from './init-auth-api.ts'
import { initGraphql } from './init-graphql.ts'
import { initRevolugoDesignSystem } from './init.ts'

import type { App } from 'vue'

export { configureAuthApiUrl } from '#services/api-client'

export function initRevolugoDesignSystemWithClients(app: App) {
  initRevolugoDesignSystem(app)
  initGraphql(app)
  initAuthApi(app)
}
